import { createContext, useContext } from "react";
import { notification } from "antd";

type data = {
  message: string;
  description?: string;
};

const NotificationContext = createContext({
  success: (data: data) => {},
  error: (data: data) => {},
  info: (data: data) => {},
  warning: (data: data) => {},
});

export const NotificationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [api, contextHolder] = notification.useNotification();
  const defaultSetting = {
    showProgress: true,
    pauseOnHover: true,
  };

  const notify = {
    success: ({ message, description }: data) =>
      api.success({
        message,
        description,
        ...defaultSetting,
      }),
    error: ({ message, description }: data) =>
      api.error({
        message,
        description,
        ...defaultSetting,
      }),
    info: ({ message, description }: data) =>
      api.info({
        message,
        description,
        ...defaultSetting,
      }),
    warning: ({ message, description }: data) =>
      api.warning({
        message,
        description,
        ...defaultSetting,
      }),
  };

  return (
    <NotificationContext.Provider value={notify}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotify = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotify must be used within an AlertProvider");
  }
  return context;
};
